import { Row, Col } from 'react-bootstrap';
import SelectInput from '../SelectInput';
import TextInput from '../TextInput';
import states from './constants';
import { ManualAddressInputProps } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ManualAddressInput = (props: ManualAddressInputProps & any) => {
    const {
        name,
        ...rest
    } = props;
    return (
        <>
            <TextInput
                key={`${name}.line1`}
                name={`${name}.line1`}
                label='Address line 1'
                {...rest}
            />
            <TextInput
                key={`${name}.line2`}
                name={`${name}.line2`}
                label='Address line 2'
                {...rest}
            />
            <TextInput
                key={`${name}.line3`}
                name={`${name}.line3`}
                label='Address line 3'
                {...rest}
            />
            <TextInput
                key={`${name}.suburb`}
                name={`${name}.suburb`}
                label='Suburb'
                {...rest}
            />
            <Row>
                <Col md={6}>
                    <TextInput
                        key={`${name}.postcode`}
                        name={`${name}.postcode`}
                        label='Postcode'
                        {...rest}
                    />
                </Col>
                <Col md={6}>
                    <SelectInput<string>
                        key={`${name}.state`}
                        name={`${name}.state`}
                        label='State'
                        options={states}
                        addBlank
                        {...rest}
                    />
                </Col>
            </Row>
        </>
    );
};

export default ManualAddressInput;
